module.exports = __webpack_public_path__ + "static/media/aws1.0e8f46e9.jpg";